/* eslint-disable */

export enum ConversationStatus {
  NONE = "NONE",
  /**
   * ACTION_REQUIRED - Contains at least one payment that is waiting on you where you aren't a bill getter.
   * Takes precedence over OUTSTANDING_REQUEST.
   */
  ACTION_REQUIRED = "ACTION_REQUIRED",
  /** OUTSTANDING_REQUEST - Contains at least one request that is waiting on either you or them. */
  OUTSTANDING_REQUEST = "OUTSTANDING_REQUEST",
}

/**
 * This is obsolete, but kept around because iOS versions up to 2.39 or 2.40 expect a
 * conversation_token to be present.
 */
export interface PaymentConversationData {
  /** The token that identifies which conversation this payment belongs to. */
  conversation_token?: string;
  /**
   * The headline to use for the conversation if the payment has the highest headline_priority of
   * all payments in the conversation.
   */
  headline?: string;
  /**
   * The conversation status that the payment contributes to the conversation. The conversation has
   * various display attributes (like green headline text) based on the conversation status of its
   * payments.
   */
  status?: ConversationStatus;
  /**
   * The priority of this payment's headline as compared to other payments in the conversation.
   * The conversation uses the headline of the payment with the highest headline_priority.
   */
  headline_priority?: number;
  /**
   * The order of conversations in the conversation list is determined by the sort_priority.
   * The priority of each conversation is determined by the highest sort_priority of its payments.
   * Conversations are sorted in descending order.
   */
  sort_priority?: number;
}
